/** block name in structure tree */
export const CONTENT_TAB_CROSS_SALE = 'Вкладка Аксессуары';
export const WIDGET_CROSS_SALE = 'С этим товаром также покупают';
export const WIDGET_RECENTLY_VIEWED = 'Вы недавно просматривали';
/**
 * use positionGTMEnum to standartize actionField {list} in gtm events
 */
export const positionGTMEnum = {
  CONTENT_TAB_CROSS_SALE,
  WIDGET_CROSS_SALE,
  WIDGET_RECENTLY_VIEWED,
};

/** names for GTM param EVENT_LOAD_DETAILS */
export const GOOD_OF_DAY_EVENT_NAME = 'Товар дня';
export const CATALOG_EVENT_NAME = 'Каталог';

export const clickPlace = {
  PDP: 'pdp',
  POPUP: 'pop-up',
};

export const searchTakeAwayOfficesResult = {
  FAIL: 'fail',
  SUCCESS: 'success',
};

export const subscriprionSuccessName = 'SubscriptionSuccess';
